<template>
  <div class="box adv" v-if="isAdvBannerActive && isLangPl">
    <a href="" @click.prevent="goToAutoTopup">
      <img src="/images/orange/banners/pl/baner_Autodoladowanie_20zl_410x270-k.svg" alt="20 zł ekstra dla nowego numeru za pierwsze Autodoładowanie za min. 31zł">
    </a>
  </div>
</template>

<script>
import { PROMO_AUTOTOPUP } from '@/orange/const/promo.const'
import { DateClass } from '@/common/class/date.class'
import { ROUTING } from '@/orange/const/routing.const'
import { LANG } from '@/common/const/lang.const'

export default {
  name: 'ContactsAdv',
  computed: {
    isAdvBannerActive: function () {
      return DateClass.isDateActive(PROMO_AUTOTOPUP.dateStart, PROMO_AUTOTOPUP.dateEnd)
    },
    isLangPl: function () {
      return this.$i18n.locale() === LANG.pl
    }
  },
  methods: {
    goToAutoTopup () {
      this.$router.push(ROUTING.topup.auto.step1)
    }
  }
}
</script>
